import { useEffect, useRef, useState } from 'react';
import {
  getCourseDetails,
  getCourseGradeProgress,
  getUserCourseCompletionApi,
  getUserProgress,
} from './utils/courseIframe';

function useCourseIframe(courseID: string) {
  const hasFetchedData = useRef(false);

  const [courseDetails, setCourseDetails] = useState({});
  const [courseLoaded, setCourseLoaded] = useState(false);
  const [courseCompletion, setCourseCompletion] = useState({});
  const [courseCompletionLoaded, setCourseCompletionLoaded] = useState(false);
  const [courseGradeProgress, setCourseGradeProgress] = useState({});
  const [courseGradeProgressLoaded, setCourseGradeProgressLoaded] =
    useState(false);

  useEffect(() => {
    if (!hasFetchedData.current) {
      getCourseDetails(courseID, courseDetailsCallback);
      getUserCourseCompletionApi(courseID, courseCompletionCallback);
      getCourseGradeProgress(courseID, courseGradeProgressCallback);
      getUserProgress(courseID, getUserProgressCallback);
      hasFetchedData.current = true;
    }
  }, []);

  const getUserProgressCallback = (data) => {
    console.log(data);
  };

  const courseDetailsCallback = (data) => {
    setCourseDetails(data);
    setCourseLoaded(true);
  };

  const courseGradeProgressCallback = (data) => {
    setCourseGradeProgress(data);
    setCourseGradeProgressLoaded(true);
  };

  const courseCompletionCallback = (data) => {
    setCourseCompletion(data);
    setCourseCompletionLoaded(true);
  };

  return [
    courseDetails,
    courseLoaded,
    courseCompletion,
    courseCompletionLoaded,
    courseGradeProgress,
    courseGradeProgressLoaded,
  ];
}

export { useCourseIframe };
